<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-10-25 18:40:54
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-10 10:43:58
 * @Description: 
-->
<template>
  <div>
    <table-manager :tableData="tableData" ref="tableForm"></table-manager>
    <div class="footerBtn">
      <!-- <el-button @click="pre">取消</el-button> -->
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableManager from "../managerTable";
import comMixin from "common/js/mixin/comMixin";
import {
  getReportDetail,
  updateRecordBasic,
  saveReportBasic,
} from "common/js/api";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    TableManager,
  },

  data() {
    return {
      tableData: {},
      codeId: this.$route.query.codeId,
      step: 0,
    };
  },

  mixins: [comMixin],

  mounted() {
    console.log("x step1");
    this.getData();
  },

  methods: {
    async getData() {
      const res = await getReportDetail(this.codeId);

      this.setReportData({
        codeId: this.codeId,
        value: res.result,
        institutionCode:this.$route.query.institutionCode,
        reportFillType: this.$route.query.reportFillType,
      });
      this.tableData = res.result.basic;
    },
    //新增基金管理机构基本信息
    async save() {
      const form = this.$refs.tableForm.form;
      console.log("step 1 save form :", form);
      if (form.associtionRegisted === "是") {
        form.associtionRegisted = 1;
      } else if (form.associtionRegisted === "否") {
        form.associtionRegisted = 0;
      }

      if (form.isRegisting === "是") {
        form.isRegisting = 1;
      } else if (form.isRegisting === "否") {
        form.isRegisting = 0;
      }


      const res = await saveReportBasic(form);
      this.$message({
        message: "保存基本信息成功",
        type: "success",
      });
      return true;
    },

    ...mapMutations(["setReportData"]),
  },
};
</script>

<style>
</style>
